import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import {
  SIDENAV_CONFIG,
  SidenavConfig,
  SidenavDefaults,
  SidenavRef,
} from '@shared/modules/sidenav/models/sidenav.models';

@Component({
  templateUrl: './sidenav-container.component.html',
  styleUrls: ['./sidenav-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: SidenavRef, useExisting: SidenavContainer }],
  standalone: false,
})
export class SidenavContainer<T = void> extends SidenavRef<T> {
  readonly config = inject<SidenavConfig>(SIDENAV_CONFIG);

  get isOpen(): boolean {
    return this._isOpen;
  }

  constructor() {
    super();
    const config = this.config;

    this.config = {
      ...SidenavDefaults,
      ...config,
    };
  }

  open(): void {
    this._isOpen = true;
  }
}
